package org.example.project.screens_sys

import androidx.compose.runtime.*
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.json.Json
import org.example.project.enginetabular.TabularScreen
import org.example.project.enginetabular.TabularSplitScreen
import org.example.project.manager.LumaticaApiManager
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

private object WebseitenWiederkehrerApi {
    private val json = Json { ignoreUnknownKeys = true }

    suspend fun load(): List<All> = json.decodeFromString<All>(
        LumaticaApiManager.call("webseitenuebersicht/wiederkehrer")
    ).webseitenWiederkehrer
}

@Composable
fun SysWebseitenWiederkehrer() {
    val scope = rememberCoroutineScope()
    var visitors by remember { mutableStateOf<List<All>>(emptyList()) }
    var selectedIp by remember { mutableStateOf<String?>(null) }
    var error by remember { mutableStateOf(false) }

    suspend fun reload() {
        try {
            visitors = WebseitenWiederkehrerApi.load()
            if (visitors.none { it.webseitenIp == selectedIp }) selectedIp = null
            error = false
        } catch (exception: Exception) {
            if (exception is CancellationException) throw exception
            error = true
        }
    }

    LaunchedEffect(Unit) { reload() }

    val selectedVisitor = visitors.firstOrNull { it.webseitenIp == selectedIp }

    Div({ style { width(100.percent); height(100.percent); minHeight(0.px); display(DisplayStyle.Flex); flexDirection(FlexDirection.Column) } }) {
        if (error) Div({ style { padding(8.px) } }) { Text("Besuchsdaten konnten nicht geladen werden.") }
        Div({ style { flex("1"); minHeight(0.px); overflow("hidden") } }) {
            TabularSplitScreen(
                initialRatio = 0.42f,
                minRatio = 0.20f,
                maxRatio = 0.75f,
                screen1 = {
                    Div({ style { flex("1"); minHeight(0.px); overflow("hidden") } }) {
                        TabularScreen(
                            screenKey = "WebseitenWiederkehrer",
                            title = "Wiederkehrende Besucher",
                            headers = listOf("Datum", "Uhrzeit", "IP-Adresse", "Wiederholungen", "Seitenadresse", "Flyer Downloads", "Gesamtdauer"),
                            data = visitors.map { visitor ->
                                visitor.webseitenIp to listOf(
                                    visitor.webseitenDatum,
                                    visitor.webseitenUhrzeit,
                                    visitor.webseitenIp,
                                    visitor.webseitenWiederholteBesuche.toString(),
                                    visitor.webseitenSeitenadresse,
                                    visitor.webseitenFlyerDownloads.toString(),
                                    formatWebsiteDuration(visitor.webseitenGesamtdauer)
                                )
                            },
                            editable = false, hardReadOnly = true, includeMetadata = false,
                            allowCreate = false, allowSave = false, allowDelete = false,
                            allowImportButton = false, allowExportButton = true,
                            allowSettingsButton = false, allowRefreshButton = true,
                            onRefresh = { scope.launch { reload() } },
                            onRowClick = { selectedIp = it },
                            onCommit = {}, showFillerRows = false,
                            dataColumnWidthCss = "120px 100px 150px 150px minmax(310px, 1fr) 130px 130px"
                        )
                    }
                },
                screen2 = selectedVisitor?.let { visitor -> {
                    Div({ style { flex("1"); minHeight(0.px); overflow("hidden") } }) {
                        TabularScreen(
                            screenKey = "WebseitenWiederkehrerBesuche",
                            title = "Besuchslogs von ${visitor.webseitenIp}",
                            headers = listOf("Datum", "Uhrzeit", "Seitenadresse", "Seitenaufrufe", "Flyer Downloads", "Sitzungsdauer"),
                            data = visitor.webseitenBesuche.map { visit ->
                                visit.webseitenBesuchId to listOf(
                                    visit.webseitenDatum,
                                    visit.webseitenUhrzeit,
                                    visit.webseitenEinstieg,
                                    visit.webseitenSeiten.size.toString(),
                                    visit.webseitenFlyerDownloads.toString(),
                                    formatWebsiteDuration(visit.webseitenSitzungsdauer)
                                )
                            },
                            editable = false, hardReadOnly = true, includeMetadata = false,
                            allowCreate = false, allowSave = false, allowDelete = false,
                            allowImportButton = false, allowExportButton = true,
                            allowSettingsButton = false, allowRefreshButton = false,
                            onCommit = {}, showFillerRows = false,
                            dataColumnWidthCss = "120px 100px minmax(310px, 1fr) 130px 130px 130px"
                        )
                    }
                } }
            )
        }
    }
}
